import {TableContainer, TableHead, TableBody, TableCell, TableRow, Paper, Table, Grid} from '@mui/material';
import {useTranslation} from "react-i18next";
import {observer} from 'mobx-react';
import React from 'react';
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TAB_TIME, TAB_MONTH_SUM} from './StatsCommon.js';
import StatsFilter from './StatsFilter.js';
import {monthNames} from '../Trans.js'
import {COMM_OK} from '../WsR2.js';

const StatsMonthSumList = observer((props) => {
	let tot_cnt, tot_num, tot_spec, tot_city;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	tot_cnt = 0;
	tot_num = 0;
	tot_spec = 0;
	tot_city = 0;

	return (
		<TableContainer component={Paper} elevation={0}>
			<Table size='small'>
				<TableHead>
					<TableRow>
						<TableCell align='center' padding='checkbox'>#</TableCell>
						<TableCell>{t('stats.month')}</TableCell>
						<TableCell align='right' padding='checkbox'>{t('taxons.count2')}</TableCell>
						<TableCell align='right' padding='checkbox'>{t('taxons.num2')}</TableCell>
						<TableCell align='right' padding='checkbox'>{t('stats.num_species')}</TableCell>
						<TableCell align='right'  padding='checkbox'>{t('taxons.cities')}</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{gStorage.stats.obsList && gStorage.stats.obsList.map((m, i) => {
						tot_cnt += m.cnt;
						tot_num += m.num;
						tot_spec += m.n_spec;
						tot_city += m.n_city;

						return (<TableRow key={m.month}>
								<TableCell align='center' padding='checkbox'>{m.month}</TableCell>
								<TableCell >{t(monthNames[m.month - 1])}</TableCell>
								<TableCell align='right' padding='checkbox'>{m.cnt}</TableCell>
								<TableCell align='right' padding='checkbox'>{m.num}</TableCell>
								<TableCell align='right' padding='checkbox'>{m.n_spec}</TableCell>
								<TableCell align='right' padding='checkbox'>{m.n_city}</TableCell>
							</TableRow>);
					})}

					{gStorage.stats.obsList && gStorage.stats.obsList.length > 0 &&
					<TableRow key={13}>
						<TableCell align='center' padding='checkbox' style={{fontWeight: 'bold', border: 0}}></TableCell>
						<TableCell style={{fontWeight: 'bold', border: 0}}></TableCell>
						<TableCell align='right' padding='checkbox' style={{fontWeight: 'bold', border: 0}}>{tot_cnt}</TableCell>
						<TableCell align='right' padding='checkbox' style={{fontWeight: 'bold', border: 0}}>{tot_num}</TableCell>
						<TableCell align='right' padding='checkbox' style={{fontWeight: 'bold', border: 0}}>{tot_spec}</TableCell>
						<TableCell align='right' padding='checkbox' style={{fontWeight: 'bold', border: 0}}>{tot_city}</TableCell>
					</TableRow>
					}
				</TableBody>
			</Table>
		</TableContainer>
	)
});

const StatsMonthSum = observer((props) => {
	const gStorage = useGlobalStorage();

	function monthSumyearChange(event) {
		gStorage.stats.setStatsYear(event.target.value);
		gStorage.stats.setObsList(null);
	}

	// function monthSumAllChange(event, value) {
	// 	gStorage.stats.setAllUsers(!gStorage.stats.allUsers);
	// 	gStorage.stats.setObsList(null);
	// }

	function monthSumRxWs(status, msg) {
		if (status !== COMM_OK) {
			alert('monthSumRxWs: error ' + status);
			return;
		} else if (msg.result !== 'OK') {
			alert('monthSumRxWs: ' + msg.data.desc + '!');
			return;
		}

		if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_MONTH_SUM)
			return;

// 		console.log('monthSumRxWs', msg);
		gStorage.stats.setObsList(msg.data.summary);
	}

	function loadMonthSum() {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'month',
			op: 'summary',
			data: {
				country: gStorage.stats.country.id,
				year: gStorage.stats.statsYear,
				user: /*gStorage.stats.allUsers ? 0 : */gStorage.conn.user.id,
			}
		}
// 		console.log('loadMonthStats', msg);
		gStorage.conn.ws.send(msg, monthSumRxWs);
	}

	if (gStorage.stats.tab !== TAB_TIME || gStorage.stats.time_tab !== TAB_MONTH_SUM)
		return null;

	if (!gStorage.stats.obsList && gStorage.conn.online)
		loadMonthSum();

	return (
		<div>
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0}>
				<Grid size={{xs: 12}} align={'center'}>
					<StatsFilter 
						loc = {{country: {
								value: gStorage.stats.country,
								style: {width: 200}
							}
						}}
						time = {{
							year: {
								year: gStorage.stats.statsYear,
								onChange: monthSumyearChange,
								enabled: gStorage.conn.online,
								allowNone: true
							}
						}}
						// all_users = {{
						// 	checked: gStorage.stats.allUsers,
						// 	onChange: monthSumAllChange,
						// 	enabled: gStorage.conn.online
						// }}
					/>
				</Grid>
			</Grid>

			<StatsMonthSumList />
		</div>
	);
});

export default StatsMonthSum;
